import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { HisCoreSharedModule } from '../../../../../../core/his-core-shared.module';
import { HisTableSharedModule } from '../../../../../../table/his-table-shared.module';

@Component( {
    standalone: true,
    selector: 'his-bi-flat-table-toolbar',
    templateUrl: './table-toolbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HisCoreSharedModule, HisTableSharedModule]
} )
export class TableToolbarComponent {
    @Input() treeTable: boolean = false;
    @Input() configTable: boolean = false;
    @Input() simplifiedTable?: boolean;
    @Input() rowcount?: number;
    @Input() selectableColumns: any[] = [];
    @Input() configuredColumns: any[] = [];
    @Input() reorderable: boolean = false;
    @Input() canFreezeColumns: boolean = true;
    @Input() filterActive: boolean = true;
    @Output() filterActiveChange = new EventEmitter<boolean>();
    @Output() saved = new EventEmitter();
    @Output() filterChanged = new EventEmitter();
    @Output() resetFilter = new EventEmitter();
    @Output() toggleTree = new EventEmitter<{ state: 'expand' | 'collapse' }>();
    @Output() toggleSimplifiedTable = new EventEmitter();

    simplifiedTableHelptext: boolean = false;

    onSaved( event: any ) {
        this.saved.emit( event );
    }

    onFilterChanged( newValue: boolean ) {
        this.filterActive = newValue;
        this.filterActiveChange.emit( this.filterActive );
    }

    onResetFilter() {
        this.resetFilter.emit();
    }

    onExpandTree() {
        this.toggleTree.emit( { state: 'expand' } );
    }

    onCollapseTree() {
        this.toggleTree.emit( { state: 'collapse' } );
    }

    onToggleSimplifiedTable() {
        this.toggleSimplifiedTable.emit();
    }
}
